// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  getCallbackConfig,
  listEvents,
  ping,
  list,
  $delete,
  update,
  create,
  get,
} from "./operations.js";
export {
  type WebhooksGetCallbackConfigOptionalParams,
  type WebhooksListEventsOptionalParams,
  type WebhooksPingOptionalParams,
  type WebhooksListOptionalParams,
  type WebhooksDeleteOptionalParams,
  type WebhooksUpdateOptionalParams,
  type WebhooksCreateOptionalParams,
  type WebhooksGetOptionalParams,
} from "./options.js";
